import { useTranslation } from "react-i18next";
import { Badge } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/client/components/consent-list/ConsentStatusLabel.tsx
const statusVariants = {
	ACTIVE: "success",
	DECLINED: "error",
	REVOKED: "error"
};
const ConsentStatusLabel = ({ status }) => {
	const { t } = useTranslation("cons");
	let label = "";
	switch (status) {
		case "ACTIVE":
			label = t("consentStatus.accepted");
			break;
		case "DECLINED":
			label = t("consentStatus.declined");
			break;
		case "REVOKED":
			label = t("consentStatus.revoked");
			break;
	}
	return /* @__PURE__ */ jsx(Badge, {
		color: statusVariants[status],
		variant: "light",
		children: label
	});
};

//#endregion
export { ConsentStatusLabel };